// extracted by mini-css-extract-plugin
export default {"cookiesContainer":"Cookies_cookiesContainer__IKPtj","cookiesTitle":"Cookies_cookiesTitle__Ddhy3"};